export default function PageLayout({ children, theme }: { children: React.ReactNode, theme?: string }) {
  return (
    <>
      <div data-theme={ theme }>
        { children }
      </div>
    </>
  );
}
